import { CurrentTier } from './resolveCurrentTier';

// 'ultimate_2026' (não 'ultimate') pra casar com a chave de NewTierPlan/plan_type do catálogo —
// 'ultimate' é o plan_type do Ultimate legado, mantido como fallback com a precificação 2026 off.
type PaidTier = 'one' | 'ultimate_2026' | 'black';

const ALL_PAID_TIERS: PaidTier[] = ['one', 'ultimate_2026', 'black'];

const UPGRADE_LADDER: Record<CurrentTier, PaidTier[]> = {
  grandfathered: ALL_PAID_TIERS,
  degustacao: ALL_PAID_TIERS,
  one: ['ultimate_2026', 'black'],
  ultimate: ['black'],
  black: [],
};

export type GetUpgradeOptionsParams = {
  forReactivation?: boolean;
};

export const getUpgradeOptions = (
  currentTier: CurrentTier,
  { forReactivation = false }: GetUpgradeOptionsParams = {},
): PaidTier[] => {
  if (forReactivation) {
    return ALL_PAID_TIERS;
  }

  return UPGRADE_LADDER[currentTier] ?? [];
};
